import { App, message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import React from 'react';
import { getUserFacingErrorMessage } from './userFacingError';

let messageInstance: MessageInstance | null = null;

const getMessageApi = () => messageInstance ?? message;

export const setAppMessageInstance = (instance: MessageInstance | null) => {
  messageInstance = instance;
};

export const appMessage = {
  success: (content: React.ReactNode) => getMessageApi().success(content),
  error: (content: React.ReactNode) =>
    getMessageApi().error(
      typeof content === 'string'
        ? getUserFacingErrorMessage(new Error(content), '操作失败，请稍后重试')
        : content,
    ),
  warning: (content: React.ReactNode) => getMessageApi().warning(content),
  info: (content: React.ReactNode) => getMessageApi().info(content),
  loading: (content: React.ReactNode) => getMessageApi().loading(content),
};

export const AppMessageBridge: React.FC = () => {
  const { message } = App.useApp();

  React.useEffect(() => {
    setAppMessageInstance(message);
    return () => setAppMessageInstance(null);
  }, [message]);

  return null;
};
